import LoginForm from './LoginForm';
import GoogleSocialLogin from './GoogleSocialLogin';

export {
    LoginForm,
    GoogleSocialLogin,
};
